<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="5" :sm="15">
            <a-form-item label="题目">
              <a-input v-model.trim="queryParam.keyWord" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="22">
            <a-form-item label="开始日期" style="margin-left: 5px">
              <a-date-picker
                v-model="queryParam.time1"
                style="width: 100%"
                show-time
                :disabled-date="disabledStartDate"
                format="YYYY-MM-DD"
                @change="onChange1"
                @ok="onOk1"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="22">
            <a-form-item label="结束日期">
              <a-date-picker
                v-model="queryParam.time2"
                style="width: 100%"
                show-time
                :disabled-date="disabledEndDate"
                format="YYYY-MM-DD"
                @change="onChange2"
                @ok="onOk2"
              />
            </a-form-item>
          </a-col>

          <a-col :span="22" style="text-align: right; margin-right: 8px">
            <a-button type="primary" htmlType="submit" style="margin-right: 8px" @click="$refs.table.refresh(true)"
              >查询</a-button
            >
            <a-button style="margin-left: 8px" @click="() => (queryParam = {})">清空</a-button>
          </a-col>

          <a-col style="text-align: right">
            <a-button type="primary"
              ><a href="/考试题目模板.xlsx" download="考试题目模板.xlsx" style="text-decoration: none"
                >下载导入模板</a
              ></a-button
            >

            <a-upload
              style="margin: 0 8px"
              name="file"
              :action="uploadUrl"
              @change="handleChange"
              :headers="headers"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              :showUploadList="false"
            >
              <a-button type="primary"> 导入 </a-button>
            </a-upload>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator"></div>
    <s-table size="default" ref="table" rowKey="id" :columns="columns" :data="loadData" bordered>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record.questionId)">修改</a>
        <a-divider type="vertical" />
        <a @click="handleInfo(record)">详情</a>
      </span>
      <span slot="action2" slot-scope="text, record" style="white-space: normal">
        {{ text }}
      </span>
    </s-table>
    <examinationEdit ref="modal" @ok="handleOk" />
    <examinationInfo ref="modalInfo" @ok="handleOk" />

    <a-modal
      title="导入失败文件"
      style="top: 20px"
      v-model="bisible"
      @ok="handleSubmit2"
      :closable="false"
      :maskClosable="false"
    >
      <div style="margin-left: 50px">
        <p>
          <strong>导入成功数量 : </strong>
          <span>{{ success }}</span>
        </p>
        <p>
          <strong>导入失败数量 : </strong>
          <sapn style="color: red">{{ err }}</sapn>
        </p>
        <strong v-if="err == 0">全部导入成功！</strong>
        <strong v-else>是否下载导入失败文件？</strong>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import pick from 'lodash.pick'
import moment from 'moment'
import { queryOrderList } from '@/api/master/examinationList'
import examinationEdit from './modules/examinationEdit.vue'
import examinationInfo from './modules/examinationInfo.vue'
import { checkPermission } from '@/utils/permissions'
import NoAuthority from '../enterprise/NoAuthority'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'TableList',
  components: {
    STable,
    examinationEdit,
    examinationInfo,
    NoAuthority,
  },
  data() {
    return {
      data: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/system/sysExam/batchOrderImport',
      importEnabel: checkPermission('master:masterList:import'),
      bisible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 字典为安装类型
      auditStatus: [],
      reasonPriceType: [],
      arrList: '',
      success: '',
      err: '',
      // 表头
      columns: [
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '题目',
          dataIndex: 'title',
          scopedSlots: { customRender: 'action2' },
        },

        {
          title: '更新日期',
          align: 'center',
          dataIndex: 'updateTime',
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        let dd = queryOrderList(Object.assign(parameter, this.queryParam))
        return queryOrderList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      selectedRows: [],
    }
  },
  filters: {},
  async created() {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    handleEdit(id) {
      this.$refs.modal.edit(id)
    },
    handleInfo(record) {
      this.$refs.modalInfo.edit(record)
    },
    handleOk() {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },

    // 导入
    handleChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        let file = info.file.response.code
        if (file == 0) {
          this.$message.success('导入成功')
          this.$refs.table.refresh(true)
        } else {
          // this.bisible = true
          this.$message.error(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 导入失败.`)
      }
    },

    // 失败文件处理
    handleSubmit2() {
      if (this.err == 0) {
        this.bisible = true
      } else {
        downloadErrorMaster(this.arrList).then((res) => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          const a = document.createElement('a')
          // 生成文件路径
          let href = window.URL.createObjectURL(blob)
          a.href = href
          let fileName = '导入失败师傅文件'
          // 文件名中有中文 则对文件名进行转码
          a.download = decodeURIComponent(fileName)
          // 利用a标签做下载
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(href)
        })
        this.bisible = true
      }
    },
    onChange1(value, dateString) {
      this.queryParam.startTime = dateString
    },
    onChange2(date, dateString) {
      this.queryParam.endTime = dateString
    },
  },
  watch: {},
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
